module.exports = __webpack_public_path__ + "images/81d2305b50517b4ca127d9037e0ee80f-Discover Los Angeles.png";